// extracted by mini-css-extract-plugin
module.exports = {"container":"gg-z","creativeContainer":"hg-z","copy":"ig-z","cta":"jg-z","disabled":"kg-z","flipped":"lg-z","card":"mg-z"};